<template>
  <div class="text-countown">
    <span v-if="!isStarted">
      {{ days }}d : {{ hours }}h : {{ minutes }}m : {{ seconds }}s
    </span>
    <span v-else>
      VAI COMEÇAR EM BREVE!
    </span>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: {
      timestamp: {
        type: Number,
        required: true
      }
    },
    data: () => ({
      duration: null
    }),
    mounted () {
      const setDuration = () => this.duration = moment.duration(this.timestamp - Math.floor(Date.now() / 1000), 'seconds')
      setInterval(() => setDuration(), 1000)
      setDuration()
    },
    computed: {
      isStarted () {
        return this.duration && (this.duration.seconds() < 0 || this.duration.minutes() < 0 || this.duration.hours() < 0)
      },
      seconds () {
        return this.duration ? ('0' + this.duration.seconds()).slice(-2) : '00'
      },
      minutes () {
        return this.duration ? ('0' + this.duration.minutes()).slice(-2) : '00'
      },
      hours () {
        return this.duration ? ('0' + this.duration.hours()).slice(-2) : '00'
      },
      days () {
        return this.duration ? this.duration.days() : '0'
      }
    }
  }
</script>

<style scoped lang="scss">
  .text-countown {
    font-weight: 600;
    font-size: 15px;
    color: #fff;
  }
</style>